/* eslint-disable react/destructuring-assignment, react/prop-types */
import { Typography } from '@material-ui/core';
import { captureReactException } from '@sentry/react';
import React from 'react';

const INITIAL_STATE = {
  componentStack: null,
  error: null,
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  componentDidCatch(error, errorInfo) {
    const { componentStack } = errorInfo;

    captureReactException(error, errorInfo, {
      mechanism: { type: 'react.error_boundary' },
    });

    // componentDidCatch is used over getDerivedStateFromError
    // so that componentStack is accessible through state.
    this.setState({ error, componentStack });
  }

  resetErrorBoundary() {
    this.setState(INITIAL_STATE);
  }

  render() {
    if (!!this.state.error) {
      // You can render any custom fallback UI
      return (
        React.cloneElement(this.props.fallback, {
          error: this.state.error,
          componentStack: this.state.componentStack,
          resetError: () => this.resetErrorBoundary(),
        }) || <Typography align="center">Something went wrong.</Typography>
      );
    }

    return this.props.children;
  }
}

function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
  const componentDisplayName =
    WrappedComponent.displayName || WrappedComponent.name;

  const Wrapped = React.memo((props) => (
    <ErrorBoundary {...errorBoundaryOptions}>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  ));

  Wrapped.displayName = `errorBoundary(${componentDisplayName})`; // Copy over static methods from Wrapped component to Profiler HOC // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over

  return Wrapped;
}

export default ErrorBoundary;
export { withErrorBoundary };
